/**
 * REPUTE — Scroll Reveal Web Component
 *
 * Usage in Liquid:
 *   <scroll-reveal>Content fades up on scroll</scroll-reveal>
 *   <scroll-reveal data-effect="fade">Fade only, no movement</scroll-reveal>
 *   <scroll-reveal data-effect="slide-left">Slide from left</scroll-reveal>
 *   <scroll-reveal data-stagger>Children animate one by one</scroll-reveal>
 *   <scroll-reveal data-delay="200">Delayed reveal</scroll-reveal>
 */
class ScrollReveal extends HTMLElement {
  connectedCallback() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      this.classList.add('is-visible');
      return;
    }

    const delay = parseInt(this.dataset.delay) || 0;
    const threshold = parseFloat(this.dataset.threshold) || 0.1;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              this.classList.add('is-visible');
            }, delay);
            this.observer.unobserve(this);
          }
        });
      },
      { threshold, rootMargin: '0px 0px -40px 0px' }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (!customElements.get('scroll-reveal')) {
  customElements.define('scroll-reveal', ScrollReveal);
}
